<div id="create-tender" class="container-fluid mt-5 has-floating-actions">
  <div class="card bg-white">
    <div class="card-header bg-white">
      <div class="d-flex flex-row align-items-center">
        <h3 class="mb-0 me-6">
          Locations
        </h3>
        <div class="badge bg-secondary me-3">
          {{totalItems}} location{{totalItems !== 1 ? 's' : ''}}
        </div>
        <a (click)="addContract()" href="javascript:void(0)" class="btn btn-light" data-testid="add-location">
          <span class="me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus">
              <path
                d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" />
              <circle cx="12" cy="10" r="3" />
              <path d="M16 18h6" />
              <path d="M19 15v6" />
            </svg>
          </span> Add Location
        </a>
        <a (click)="openImportContact()" href="javascript:void(0)" class="btn btn-light ms-3" id="locations-from-excel">
          <i class="me-2 fas fa-file-upload"></i> Upload From Excel
        </a>
        <!-- Search Bar -->
        <div class="d-flex align-items-center ms-auto">
          <div class="input-group" style="max-width: 400px;">
            <span class="input-group-text bg-white">
              <span *ngIf="!loading" class="d-flex align-items-center">
                <ng-icon name="lucideSearch" size="18"></ng-icon>
              </span>
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"></span>
            </span>
            <input type="text" class="form-control" placeholder="Search by location, city, country, or company..."
              [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)">
          </div>

          <button *ngIf="searchTerm" class="btn btn-light ms-2" (click)="searchTerm = ''; onSearchChange('')"
            title="Clear search">
            <ng-icon name="lucideX" size="18"></ng-icon>
          </button>
        </div>
        <a href="javascript:void(0)" class="btn btn-light ms-2" #deleteAllPopover="ngbPopover"
          [ngbPopover]="deleteAllConfirmTemplate" [autoClose]="false" placement="bottom"
          popoverTitle="Delete All Locations" *ngIf="contracts.length > 0">
          <i class="me-2 fas fa-trash"></i> Delete All Locations
        </a>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table mb-0">
        <thead class="border-bottom">
          <tr>
            <th class="border-top-0 cursor-pointer user-select-none" (click)="onSortChange('location')">
              <div class="d-flex align-items-center">
                <span>Location</span>
                <ng-icon [name]="getSortIcon('location')" size="16" class="ms-1"></ng-icon>
              </div>
            </th>
            <th class="border-top-0 cursor-pointer user-select-none"
              *ngIf="!tender.company.settings.isHiddenField('location_company')" (click)="onSortChange('company')">
              <div class="d-flex align-items-center">
                <span>Company</span>
                <ng-icon [name]="getSortIcon('company')" size="16" class="ms-1"></ng-icon>
              </div>
            </th>
            <th class="border-top-0 cursor-pointer user-select-none"
              *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')" (click)="onSortChange('fuel_type')">
              <div class="d-flex align-items-center">
                <span>Fuel Type</span>
                <ng-icon [name]="getSortIcon('fuel_type')" size="16" class="ms-1"></ng-icon>
              </div>
            </th>
            <th class="border-top-0 cursor-pointer user-select-none"
              *ngIf="!tender.company.settings.isHiddenField('location_flight_type')"
              (click)="onSortChange('flight_type')">
              <div class="d-flex align-items-center">
                <span>Flight Type</span>
                <ng-icon [name]="getSortIcon('flight_type')" size="16" class="ms-1"></ng-icon>
              </div>
            </th>
            <th class="border-top-0" *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">Delivery
              Point</th>
            <th class="border-top-0 cursor-pointer user-select-none" (click)="onSortChange('volume')">
              <div class="d-flex align-items-center">
                <span>{{tender.company.settings.getFieldName('total_volume', 'Total Volume')}}</span>
                <ng-icon [name]="getSortIcon('volume')" size="16" class="ms-1"></ng-icon>
              </div>
            </th>
            <th class="border-top-0">Tags</th>
            <th class="border-top-0">Settings</th>
            <th class="border-top-0"></th>
            <th class="border-top-0"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td [attr.colspan]="getColspan()" *ngIf="!contracts.length">
              <p class="my-5 small text-center">No locations to display.</p>
            </td>
          </tr>
          <tr *ngFor="let contract of contracts" class="ng-touched ng-pristine ng-invalid">
            <td>
              <strong>{{contract.location.iata}}</strong>
            </td>
            <td *ngIf="!tender.company.settings.isHiddenField('location_company')">
              <span *ngIf="contract.companyChild && contract.companyChild?.name">{{
                contract.companyChild?.getDisplayName() }}</span>
              <span *ngIf="!(contract.companyChild && contract.companyChild?.name) && contract.companyInfo">{{
                contract.companyInfo }}</span>
              <span *ngIf="!(contract.companyChild && contract.companyChild?.name) && !contract.companyInfo"
                class="small text-muted">
                Not Provided
              </span>
            </td>
            <td *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
              {{tender.company.settings.getFilteredOptionLabel('fuel_type', contract.fuelType)}}
              <span *ngIf="!contract.fuelType?.name" class="small text-muted">
                Not Provided
              </span>
            </td>
            <td *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
              <span *ngIf="contract.flightType?.name">{{contract.flightType.name}}</span>
              <span *ngIf="!contract.flightType?.name" class="small text-muted">
                Not Provided
              </span>
            </td>
            <td *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
              <span *ngIf="contract.fuelPreference?.name">{{contract.fuelPreference.name}}</span>
              <span *ngIf="!contract.fuelPreference?.name" class="small text-muted">
                Not Provided
              </span>
            </td>
            <td>
              <span *ngIf="contract.volume">{{contract.volume | usNumber}}</span>
              {{contract.units ? contract.units.code : ''}}
            </td>
            <td>
              <span *ngFor="let tag of contract.tags">
                <span
                  class="badge py-1 px-2 me-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                  {{tag['name']}}
                </span>
              </span>
            </td>
            <td>
              <ng-template #tipContent>
                <div class="text-start">
                  <div *ngIf="contract.dateStart">
                    Contract start date: <strong>{{contract.dateStart | date:'dd MMM yyyy':'UTC'}}</strong><br>
                  </div>
                  <div *ngIf="contract.dateEnd">
                    Contract end date: <strong>{{contract.dateEnd | date:'dd MMM yyyy':'UTC'}}</strong><br>
                  </div>
                  <div *ngIf="contract.currency?.code">
                    Preferred currency: <strong>{{contract.currency.code}}</strong><br>
                  </div>
                  <div *ngIf="contract.units?.code">
                    Preferred units: <strong>{{contract.units.code}}</strong><br><br>
                  </div>

                  <div *ngIf="!tender.company.settings.isHiddenField('location_branded')">
                    Branded: <strong>{{ contract.branded ? 'Yes' : 'No' }}</strong><br>
                  </div>
                  <div
                    *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.annualFrequency">
                    Annual Frequency: <strong>{{contract.annualFrequency}}</strong><br>
                  </div>
                  <div
                    *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.averageUplift">
                    Average uplift: <strong>{{contract.averageUplift}}</strong><br>
                  </div>
                  <div
                    *ngIf="!tender.company.settings.isHiddenField('location_months_of_service') && contract.monthService">
                    Months of service: <strong>{{contract.monthService}}</strong><br>
                  </div>
                  <div
                    *ngIf="!tender.company.settings.isHiddenField('location_monthly_volume') && contract.monthService && contract.volume">
                    Monthly volume: <strong>{{contract.volume / contract.monthService | number : '1.0-0' | usNumber }}
                      {{
                      contract.units.code }}</strong><br>
                  </div>
                  <div *ngIf="!tender.company.settings.isHiddenField('location_award_quota') && contract.awardQuota">
                    Award quota: <strong>{{ contract.awardQuota }}%</strong><br>
                  </div>

                  <div
                    *ngIf="!tender.company.settings.isHiddenField('location_iata_service_level') && contract.iataServiceLevel?.name">
                    IATA Service Level: <strong>{{contract.iataServiceLevel.name}}</strong><br>
                  </div>

                  <div *ngIf="!tender.company.settings.isHiddenField('location_notes') && contract.notes">
                    <br>
                    Location Specific Notes:<br>{{contract.notes}}<br>
                  </div>
                </div>
              </ng-template>
              <a href="javascript:void(0);" placement="left" [ngbTooltip]="tipContent">
                <i class="fas fa-sliders-h"></i>
              </a>

            </td>
            <td class="text-end">
              <!--                                <button (click)="productServicesList(contract)" title="Edit services" class="btn btn-link">-->
              <!--                                    Product Services-->
              <!--                                </button>-->
            </td>
            <td class="text-end">
              <button (click)="editContract(contract)" title="Edit location" class="btn btn-link">
                Edit
              </button>
              <button [ngbPopover]="deleteLocationConfirmation" popoverTitle="" title="Delete location"
                class="btn btn-link ms-0 ms-md-2">
                Delete
              </button>
              <ng-template #deleteLocationConfirmation>
                <p class="mb-2"><strong>{{contract.location.iata}}</strong> will be removed
                  from this tender.</p>
                <div class="row">
                  <div class="col">
                    <button (click)="p.close()" class="btn btn-light w-100">
                      Cancel
                    </button>
                  </div>
                  <div class="col">
                    <button (click)="deleteContract(contract)" class="btn btn-danger w-100">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="card-footer bg-white border-top" *ngIf="totalItems > pageSize">
      <div class="d-flex justify-content-between align-items-center">
        <div class="pagination-info">
          <small class="text-muted">
            Showing {{ startIndex }} to {{ endIndex }} of {{ totalItems }} locations
          </small>
        </div>
        <div class="d-flex align-items-center gap-3">
          <div class="page-size-selector">
            <label class="form-label small mb-0 me-2">Items per page:</label>
            <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="pageSize"
              (ngModelChange)="onPageSizeChange($event)">
              <option value="10">10</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="totalItems" [maxSize]="5"
            [rotate]="true" [boundaryLinks]="true" (pageChange)="onPageChange($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>

  <div class="card bg-white mt-5">
    <div class="card-header bg-white">
      <h3 class="mb-0">Required Documents</h3>
    </div>

    <jft-requested-documents [tender]="tender" [documents]="requestedDocuments"></jft-requested-documents>

  </div>

</div>

<jft-submission-footer data-testid="wizard-next" backLabel="Back" backIcon="bi-arrow-left" nextLabel="Continue to Suppliers"
  nextIcon="bi-arrow-right" secondaryNextLabel="Delete Draft"
  secondaryNextClass="btn btn-link text-danger text-decoration-none fw-bold" [nextDisabled]="!contracts.length"
  [validationErrors]="!contracts.length ? ['At least one location must be added'] : []" (onBack)="stepBack()"
  (onNext)="submitContracts()" (onSecondaryNext)="deleteTender()">
</jft-submission-footer>

<!-- Delete All Locations Confirmation Popover Template -->
<ng-template #deleteAllConfirmTemplate>
  <div class="text-center">
    <p class="mb-3">Are you sure you want to delete all locations?</p>
    <div class="d-flex gap-2">
      <button class="btn btn-light btn-sm flex-fill" (click)="cancelDeleteAll()">
        Cancel
      </button>
      <button class="btn btn-danger btn-sm flex-fill" (click)="deleteAllLocations()" [disabled]="deletingAll">
        <span *ngIf="deletingAll" class="spinner-border spinner-border-sm me-1" role="status"></span>
        {{ deletingAll ? 'Deleting...' : 'Delete All' }}
      </button>
    </div>
  </div>
</ng-template>